import React from 'react'

import useFirebase from 'hooks/firebase'

import {
  Link as RouterLink,
  // NavLink,
  Route,
  Routes,
  // useLocation
} from 'react-router-dom'

import {
  AppBar,
  Box,
  Button,
  Grid,
  // List,
  // ListItem,
  // ListItemIcon,
  // ListItemText,
  Toolbar,
  Typography,
} from '@mui/material'

import LandingHome from './home'
import PrivacyPolicy from './privacy'

const Landing = (props) => {
  // const { window } = props

  // const [mobileOpen, setMobileOpen] = useState(false)

  // const handleDrawerToggle = () => {
  //   setMobileOpen(!mobileOpen)
  // }

  const { auth } = useFirebase()
  const { credentials } = auth

  const toolbarHeight = 72

  // const sections = [
  // ]

  // const drawer = (
  //   <>
  //     <Toolbar sx={{ bgcolor: '#5e17eb', minHeight: toolbarHeight }}>
  //       <Grid container>
  //         <Grid item xs align='middle'>
  //           <Box>
  //             <img
  //               src=''
  //               alt=''
  //               style={{ verticalAlign: 'middle', maxHeight: '64px' }}
  //             />
  //           </Box>
  //         </Grid>
  //       </Grid>
  //     </Toolbar>
  //     <List sx={{ p: 2 }}>
  //       {/* <ListItem sx={{ py: 0, pb: 1 }}>
  //         <ListItemText
  //           disableTypography
  //           primary={
  //             <Typography variant='subtitle2' sx={{ fontWeight: 'bold', fontSize: 12, letterSpacing: '2px', opacity: 0.9 }}>EL PAÍS</Typography>
  //           }
  //         />
  //       </ListItem> */}
  //       <ListItem button dense
  //         component={NavLink}
  //         end // https://stackoverflow.com/a/70551865
  //         to=''
  //         onClick={handleDrawerToggle}
  //         style={({ isActive }) => ({
  //           background: isActive ? '#5d4ac522' : '',
  //           borderRadius: isActive ? '8px' : '',
  //           color: isActive ? '#5d4ac5' : '',
  //         })}
  //         sx={{
  //           '&:hover': {
  //             background: '#5d4ac522',
  //             borderRadius: '8px',
  //             color: '#5d4ac5',
  //           },
  //           mb: 1,
  //           pl: 4
  //         }}
  //       >
  //         {/* <ListItemIcon sx={{ minWidth: 32 }}>
  //           <IconHome color='#5d4ac5' size={iconSize} stroke={iconStroke} />
  //         </ListItemIcon> */}
  //         <ListItemText primary='Inicio' />
  //       </ListItem>
  //       {
  //         sections.map((section) => (
  //           <ListItem 
  //             key={`section_${section.id}`}
  //             button 
  //             dense
  //             component={NavLink}
  //             end // https://stackoverflow.com/a/70551865
  //             to={section.path}
  //             onClick={handleDrawerToggle}
  //             style={({ isActive }) => ({
  //               background: isActive ? '#5d4ac522' : '',
  //               borderRadius: isActive ? '8px' : '',
  //               color: isActive ? '#5d4ac5' : '',
  //             })}
  //             sx={{
  //               '&:hover': {
  //                 background: '#5d4ac522',
  //                 borderRadius: '8px',
  //                 color: '#5d4ac5',
  //               },
  //               mb: 1,
  //               pl: 4
  //             }}
  //           >
  //             <ListItemIcon sx={{ minWidth: 32 }}>
  //               {section.icon}
  //             </ListItemIcon>
  //             <ListItemText primary={section.label} />
  //           </ListItem>
  //         ))
  //       }
  //     </List>
  //   </>
  // )

  // const container = window !== undefined ? () => window().document.body : undefined

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: 'auto 1fr auto', minHeight: '100vh' }}>
      <AppBar elevation={1} color='primary' component='nav'>
        <Toolbar sx={{ height: toolbarHeight }}>
          {/* <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton> */}
          <Box component={RouterLink} to='/'>
            <Box
              component='img'
              src='/assets/images/lightspot_web_logo.png'
              alt='Lightspot logo'
              sx= {{ maxHeight: 48, verticalAlign: 'middle' }}
            />
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }}>
            <Grid container direction='row' justifyContent='flex-end' alignItems='right'>
              {/* {navItems.map((item) => (
                <Button component={Link} href={item.path} key={`toolbar_${item.label}`} size='large' sx={{ ml: 2 }} style={{ color: '#333', letterSpacing: '4px' }}>
                  <b>{item.label}</b>
                </Button>
              ))} */}
              <Button color='secondary' component={RouterLink} to='/login' key='login' disableElevation sx={{ fontSize: 16 }} variant='contained'>
                <b style={{ fontWeight: 900 }}>{ credentials !== undefined && credentials !== null ? 'Dashboard' : 'Iniciar Sesión'}</b>
              </Button>
            </Grid>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component='main' style={{ width: '100%' }}>
        <Toolbar sx={{ height: toolbarHeight }} />
        <Routes>
          <Route path='' element={<LandingHome />} />
          <Route path='privacidad' element={<PrivacyPolicy />} />
        </Routes>
      </Box>
      <Grid container spacing={2} p={8} sx={{ bgcolor: '#4d4084' }}>
        <Grid item xs={12} md={6}>
          <Box
            component='img'
            src='/assets/images/lightspot_web_logo.png'
            sx={{ width: '60%' }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography color='white' variant='h5' gutterBottom sx={{ pb: 2 }}>
            <b style={{ fontWeight: 900 }}>Contáctanos</b>
          </Typography>
          <Typography color='white' variant='body1'>
            <a href='mailto:contacto@lightspot.mx' style={{ color: 'white', textDecoration: 'none' }}>contacto@lightspot.mx</a>
          </Typography>
        </Grid>
      </Grid>
      <Box textAlign='center' p={2} sx={{ bgcolor: '#655dc6' }}>
        <Typography color='white' align='center' variant='body1'>
          © 2022 LightSpot. Todos los derechos reservados. Conoce nuestro <RouterLink to='privacidad' style={{ color: 'white', textDecoration: 'none' }}><b>Aviso de Privacidad</b></RouterLink> y <RouterLink to='condiciones' style={{ color: 'white', textDecoration: 'none' }}><b>Términos y Condiciones</b></RouterLink>.
        </Typography>
      </Box>
    </Box>
  )
}

export default Landing